import { dialog, InputJson, toDisplayCase } from "nq-component";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import FormFactory from "../../../../../components/FormFactory";
import DialogModal from "../../../../../components/Dialog";
import DialogTable from "../../../../../components/DialogTable";
import BreakdownTable from "../../../../../components/BreakdownTable";
import ProductFormPresenter from "./ProductFormPresenter";

class ProductFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      selectedIds: {
        raw_materials: [],
        others_raw_materials: [],
        components: [],
        additional_products: [],
      },
    };
    this.presenter = new ProductFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "products";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  handleOpenAdditionalProduct() {
    const schema = this.getSchema("products");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    dialog.fire({
      html: (
        <DialogTable
          title="Additional Products"
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const prevObject = prev.object || {};
              const existingProducts = prevObject.products || [];
              const existingComponents = prevObject.components || [];
              const existingRawMaterials = prevObject.raw_materials || [];

              // ✅ Merge Products
              const productMap = new Map();
              for (const p of existingProducts) {
                productMap.set(p.id, p);
              }
              for (const p of selectedItems) {
                productMap.set(p.id, p);
              }

              // ✅ Merge Components from Products
              const componentMap = new Map();
              for (const c of existingComponents) {
                componentMap.set(c.id, c);
              }

              for (const prod of selectedItems) {
                for (const comp of prod.components || []) {
                  const existingComp = componentMap.get(comp.id);
                  componentMap.set(comp.id, {
                    ...comp,
                    quantity:
                      (existingComp?.quantity || 0) +
                      parseFloat(comp.quantity || 0),
                    stock_quantity:
                      existingComp?.stock_quantity || comp.stock_quantity || "",
                  });
                }
              }

              // ✅ Merge Raw Materials from Products
              const rawMap = new Map();
              for (const r of existingRawMaterials) {
                rawMap.set(r.id, r);
              }

              for (const prod of selectedItems) {
                for (const raw of prod.raw_materials || []) {
                  const existingRaw = rawMap.get(raw.id);
                  rawMap.set(raw.id, {
                    ...raw,
                    quantity:
                      (existingRaw?.quantity || 0) +
                      parseFloat(raw.quantity || 0),
                    stock_quantity:
                      existingRaw?.stock_quantity || raw.stock_quantity || "",
                  });
                }
              }

              return {
                object: {
                  ...prevObject,
                  products: Array.from(productMap.values()),
                  components: Array.from(componentMap.values()),
                  raw_materials: Array.from(rawMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleChangeQuantityForProducts() {
    return (e, index) => {
      const value = parseFloat(e.target.value || 0);
      const products = [...(this.state.object.products || [])];
      products[index] = {
        ...products[index],
        quantity: value,
      };

      // Recalculate based on product quantities
      const componentMap = new Map();
      const rawMap = new Map();

      for (const product of products) {
        const multiplier = parseFloat(product.quantity || 0) || 0;

        for (const comp of product.components || []) {
          const baseQty = parseFloat(comp.quantity || 0);
          const scaledQty = baseQty * multiplier;

          const existing = componentMap.get(comp.id);
          componentMap.set(comp.id, {
            ...comp,
            quantity: (existing?.quantity || 0) + scaledQty,
          });
        }

        for (const raw of product.raw_materials || []) {
          const baseQty = parseFloat(raw.quantity || 0);
          const scaledQty = baseQty * multiplier;

          const existing = rawMap.get(raw.id);
          rawMap.set(raw.id, {
            ...raw,
            quantity: (existing?.quantity || 0) + scaledQty,
          });
        }
      }

      this.setState((prev) => ({
        object: {
          ...prev.object,
          products,
          components: Array.from(componentMap.values()),
          raw_materials: Array.from(rawMap.values()),
        },
      }));
    };
  }

  // handleOpenComponent() {
  //   const schema = this.getSchema("components");
  //   const user = this.getCurrentUser();
  //   const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
  //   const storeId = user?.storeAnalytic?.[0]?.id;
  //   dialog.fire({
  //     html: (
  //       <DialogTable
  //         title="Components"
  //         where={{}}
  //         schema={schema}
  //         onCancel={() => dialog.close()}
  //         onSelect={(selectedItems) => {
  //           this.setState((prev) => {
  //             const prevObject = prev.object || {};
  //             const existingComponents = prevObject.components || [];
  //             const existingRawMaterials = prevObject.raw_materials || [];

  //             // Merge Components
  //             const componentMap = new Map();
  //             for (const comp of existingComponents) {
  //               componentMap.set(comp.id, comp);
  //             }
  //             for (const comp of selectedItems) {
  //               componentMap.set(comp.id, {
  //                 ...comp,
  //                 stock_quantity:
  //                   componentMap.get(comp.id)?.stock_quantity ||
  //                   comp.stock_quantity ||
  //                   "",
  //               });
  //             }

  //             // Merge Raw Materials with scaling
  //             const rawMap = new Map();
  //             for (const rm of existingRawMaterials) {
  //               rawMap.set(rm.id, rm);
  //             }

  //             for (const comp of selectedItems) {
  //               console.log("com", comp);
  //               const scale = comp.component_quantity
  //                 ? parseFloat(comp.quantity || 0) /
  //                   parseFloat(comp.component_quantity)
  //                 : 1;

  //               console.log("scale", scale);

  //               for (const raw of comp.raw_materials || []) {
  //                 console.log("raw", raw);
  //                 const existingRaw = rawMap.get(raw.id);
  //                 const scaledQty = Math.ceil(
  //                   parseFloat(raw.quantity || 0) * scale
  //                 );
  //                 console.log("existing", existingRaw);
  //                 console.log("scaled", scaledQty);
  //                 rawMap.set(raw.id, {
  //                   ...raw,
  //                   // quantity: scaledQty,
  //                   // quantity: (existingRaw?.quantity || 0) + scaledQty,
  //                   quantity: raw?.quantity + scaledQty,
  //                   stock_quantity:
  //                     existingRaw?.stock_quantity || raw.stock_quantity || "",
  //                 });
  //               }
  //             }

  //             return {
  //               object: {
  //                 ...prevObject,
  //                 components: Array.from(componentMap.values()),
  //                 raw_materials: Array.from(rawMap.values()),
  //               },
  //             };
  //           });
  //         }}
  //       />
  //     ),
  //     footer: false,
  //   });
  // }

  handleOpenComponent() {
    // --- tiny helpers (scoped to this method) ---
    const toNum = (v) =>
      v === undefined || v === null || v === "" ? 0 : parseFloat(String(v));

    const addNum = (a, b, digits = 6) =>
      Number((toNum(a) + toNum(b)).toFixed(digits));

    // Prefer unit cost from partial_cost/quantity if available,
    // else fall back to cost/stock_quantity (bulk pack).
    const deriveUnitCost = (rm) => {
      const q = toNum(rm.quantity);
      const pc = toNum(rm.partial_cost);
      if (pc && q) return pc / q;

      const cost = toNum(rm.cost);
      const stock = toNum(rm.stock_quantity);
      if (cost && stock) return cost / stock;

      return 0;
    };

    const schema = this.getSchema("components");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;

    dialog.fire({
      html: (
        <DialogTable
          title="Components"
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const prevObject = prev.object || {};
              const existingComponents = prevObject.components || [];
              const existingRawMaterials = prevObject.raw_materials || [];

              // ----- Merge Components -----
              const componentMap = new Map();
              for (const comp of existingComponents)
                componentMap.set(comp.id, comp);

              for (const comp of selectedItems) {
                componentMap.set(comp.id, {
                  ...comp,
                  // keep any existing stock qty if we had it already
                  stock_quantity:
                    componentMap.get(comp.id)?.stock_quantity ??
                    comp.stock_quantity ??
                    "",
                });
              }

              // ----- Merge Raw Materials WITH SCALING -----
              const rawMap = new Map();
              for (const rm of existingRawMaterials) rawMap.set(rm.id, rm);

              for (const comp of selectedItems) {
                // base = original component quantity (e.g., 1 kg)
                const baseQty = toNum(comp.component_quantity) || 1;
                // userEdited = the quantity the user set for this component (e.g., .2 kg)
                const userQty = toNum(comp.quantity);
                const scale = baseQty ? userQty / baseQty : 1;

                for (const raw of comp.raw_materials || []) {
                  const existingRaw = rawMap.get(raw.id);

                  // Quantities stay in their own UOM (kg, g, L, etc.)
                  const rawBaseQty = toNum(raw.quantity); // e.g., 0.05 kg
                  const scaledQty = rawBaseQty * scale; // keep decimals

                  // Compute scaled cost for this raw usage
                  const unitCost = deriveUnitCost(raw); // cost per raw.uom
                  const scaledCost = unitCost * scaledQty;

                  // Accumulate into map
                  rawMap.set(raw.id, {
                    ...(existingRaw || raw),
                    quantity: addNum(existingRaw?.quantity, scaledQty), // precise sum
                    partial_cost: addNum(
                      existingRaw?.partial_cost,
                      scaledCost,
                      2
                    ), // money precision
                    stock_quantity:
                      existingRaw?.stock_quantity ?? raw.stock_quantity ?? "",
                  });
                }
              }

              return {
                object: {
                  ...prevObject,
                  components: Array.from(componentMap.values()),
                  raw_materials: Array.from(rawMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleOpenRaw() {
    const schema = this.getSchema("raw_materials");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    dialog.fire({
      html: (
        <DialogTable
          title="raw_materials"
          // where={hasAdminRole ? {} : { "storeId.id": { $eq: storeId } }}
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const existing = prev.object.raw_materials || [];

              const mergedMap = new Map();
              for (const item of existing) {
                mergedMap.set(item.id, item);
              }

              for (const item of selectedItems) {
                const existingItem = mergedMap.get(item.id);
                mergedMap.set(item.id, {
                  ...item,
                  stock_quantity:
                    existingItem?.stock_quantity || item.stock_quantity || "",
                });
              }

              return {
                object: {
                  ...prev.object,
                  raw_materials: Array.from(mergedMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleOpenRawOthers() {
    const schema = this.getSchema("raw_materials");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    dialog.fire({
      html: (
        <DialogTable
          title="raw_materials"
          // where={hasAdminRole ? {} : { "storeId.id": { $eq: storeId } }}
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const existing = prev.object.others_raw_materials || [];

              const mergedMap = new Map();
              for (const item of existing) {
                mergedMap.set(item.id, item);
              }

              for (const item of selectedItems) {
                const existingItem = mergedMap.get(item.id);
                mergedMap.set(item.id, {
                  ...item,
                  stock_quantity:
                    existingItem?.stock_quantity || item.stock_quantity || "",
                });
              }

              return {
                object: {
                  ...prev.object,
                  others_raw_materials: Array.from(mergedMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  // handleOpenRawOthers() {
  //   const schema = this.getSchema("raw_materials");
  //   const user = this.getCurrentUser();
  //   const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
  //   const storeId = user?.storeAnalytic?.[0]?.id;

  //   dialog.fire({
  //     html: (
  //       <DialogTable
  //         title="raw_materials"
  //         // where={hasAdminRole ? {} : { "storeId.id": { $eq: storeId } }}
  //         where={{}}
  //         schema={schema}
  //         onCancel={() => dialog.close()}
  //         onSelect={(selectedItems) => {
  //           // REPLACE existing list entirely — no merge
  //           this.setState((prev) => ({
  //             object: {
  //               ...prev.object,
  //               others_raw_materials: selectedItems.map((item) => ({
  //                 ...item,
  //                 // set a clean default; remove any old stock_quantity
  //                 stock_quantity: "",
  //               })),
  //             },
  //           }));
  //         }}
  //       />
  //     ),
  //     footer: false,
  //   });
  // }
  s;

  onChange(value, field) {
    if (field === "itemName") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasQuantity: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  getSelectedIds(type) {
    return this.state.selectedIds[type] || [];
  }

  handleSelectAllFor(type) {
    return (e) => {
      const checked = e.target.checked;
      const allIds = (this.state.object[type] || []).map((item) => item.id);
      this.setState((prev) => ({
        selectedIds: {
          ...prev.selectedIds,
          [type]: checked ? allIds : [],
        },
      }));
    };
  }

  handleSelectOneFor(type) {
    return (e, id) => {
      const checked = e.target.checked;
      this.setState((prev) => {
        const prevIds = prev.selectedIds[type] || [];
        const updated = checked
          ? [...prevIds, id]
          : prevIds.filter((itemId) => itemId !== id);

        return {
          selectedIds: {
            ...prev.selectedIds,
            [type]: updated,
          },
        };
      });
    };
  }

  // handleChangeQuantityFor(type) {
  //   return (e, index) => {
  //     const value = e.target.value;
  //     const updated = [...(this.state.object[type] || [])];
  //     updated[index] = {
  //       ...updated[index],
  //       quantity: value,
  //     };

  //     // if (type === "components") {
  //     //   // Recalculate raw_materials based only on updated components
  //     //   const rawMap = new Map();

  //     //   for (const comp of updated) {
  //     //     const scale = comp.component_quantity
  //     //       ? parseFloat(comp.quantity || 0) /
  //     //         parseFloat(comp.component_quantity)
  //     //       : 1;

  //     //     for (const raw of comp.raw_materials || []) {
  //     //       const scaledQty = Math.ceil(parseFloat(raw.quantity || 0) * scale);

  //     //       const existing = rawMap.get(raw.id);
  //     //       rawMap.set(raw.id, {
  //     //         ...raw,
  //     //         quantity: (existing?.quantity || 0) + scaledQty,
  //     //         stock_quantity:
  //     //           existing?.stock_quantity || raw.stock_quantity || "",
  //     //       });
  //     //     }
  //     //   }

  //     //   this.setState((prev) => ({
  //     //     object: {
  //     //       ...prev.object,
  //     //       [type]: updated,
  //     //       raw_materials: Array.from(rawMap.values()),
  //     //     },
  //     //   }));
  //     // }

  //     if (type === "components") {
  //       // --- helpers ---
  //       const toNum = (v) =>
  //         v === undefined || v === null || v === "" ? 0 : parseFloat(String(v));
  //       const addNum = (a, b, digits = 6) =>
  //         Number((toNum(a) + toNum(b)).toFixed(digits));
  //       const deriveUnitCost = (rm) => {
  //         // Prefer partial_cost per quantity (component context),
  //         // fallback to cost per stock_quantity (bulk context)
  //         const q = toNum(rm.quantity);
  //         const pc = toNum(rm.partial_cost);
  //         if (pc && q) return pc / q;

  //         const packCost = toNum(rm.cost);
  //         const packQty = toNum(rm.stock_quantity);
  //         if (packCost && packQty) return packCost / packQty;

  //         return 0;
  //       };

  //       // Recalculate raw_materials based only on updated components
  //       const rawMap = new Map();

  //       for (const comp of updated) {
  //         const baseQty = toNum(comp.component_quantity) || 1; // original component qty
  //         const userQty = toNum(comp.quantity); // edited qty
  //         const scale = baseQty ? userQty / baseQty : 1;

  //         for (const raw of comp.raw_materials || []) {
  //           const existing = rawMap.get(raw.id);
  //           const rawBaseQty = toNum(raw.quantity); // in its own UOM
  //           const scaledQty = rawBaseQty * scale; // keep decimals

  //           // --- cost scaling (optional but recommended) ---
  //           const unitCost = deriveUnitCost(raw); // cost per UOM
  //           const scaledCost = unitCost * scaledQty;

  //           rawMap.set(raw.id, {
  //             ...(existing || raw),
  //             // accumulate quantitatively with precision
  //             quantity: addNum(existing?.quantity, scaledQty),
  //             // accumulate cost; money to 2 decimals
  //             partial_cost: addNum(existing?.partial_cost, scaledCost, 2),
  //             stock_quantity:
  //               existing?.stock_quantity ?? raw.stock_quantity ?? "",
  //           });
  //         }
  //       }

  //       this.setState((prev) => ({
  //         object: {
  //           ...prev.object,
  //           [type]: updated,
  //           raw_materials: Array.from(rawMap.values()),
  //         },
  //       }));
  //     } else {
  //       // Default behavior
  //       this.setState((prev) => ({
  //         object: {
  //           ...prev.object,
  //           [type]: updated,
  //         },
  //       }));
  //     }
  //   };
  // }

  handleChangeQuantityFor(type) {
    return (e, index) => {
      const value = e.target.value;
      const updated = [...(this.state.object[type] || [])];
      updated[index] = { ...updated[index], quantity: value };

      if (type !== "components") {
        this.setState((prev) => ({
          object: { ...prev.object, [type]: updated },
        }));
        return;
      }

      // ---------- helpers ----------
      const toNum = (v) =>
        v === undefined || v === null || v === "" ? 0 : parseFloat(String(v));

      const addNum = (a, b, digits = 6) =>
        Number((toNum(a) + toNum(b)).toFixed(digits));

      const deriveUnitCost = (rm) => {
        const q = toNum(rm.quantity);
        const pc = toNum(rm.partial_cost);
        if (pc && q) return pc / q; // cost per UOM from component context
        const packCost = toNum(rm.cost);
        const packQty = toNum(rm.stock_quantity);
        return packCost && packQty ? packCost / packQty : 0;
      };

      // ---------- recompute component-derived raws ----------
      const compRawMap = new Map(); // totals from components only

      for (const comp of updated) {
        const baseQty = toNum(comp.component_quantity) || 1; // original size (e.g., 1 kg)
        const userQty = toNum(comp.quantity); // edited size (e.g., .2 kg)
        const scale = baseQty ? userQty / baseQty : 1;

        for (const raw of comp.raw_materials || []) {
          const prev = compRawMap.get(raw.id);
          const baseQ = toNum(raw.quantity); // raw usage per 1 component
          const qty = baseQ * scale; // scaled usage
          const unit = deriveUnitCost(raw);
          const cost = unit * qty;

          compRawMap.set(raw.id, {
            ...(prev || raw),
            quantity: addNum(prev?.quantity, qty),
            partial_cost: addNum(prev?.partial_cost, cost, 2),
            stock_quantity: prev?.stock_quantity ?? raw.stock_quantity ?? "",
          });
        }
      }

      // ---------- merge with existing raws (preserve manual raws) ----------
      this.setState((prev) => {
        const prevObj = prev.object || {};
        const prevRaws = prevObj.raw_materials || [];

        const merged = new Map();
        // 1) start with previous raws (manual ones will stay unless replaced)
        for (const r of prevRaws) merged.set(r.id, r);
        // 2) replace/insert component-derived raws with the recomputed totals
        for (const [id, r] of compRawMap) {
          const old = merged.get(id) || {};
          merged.set(id, { ...old, ...r }); // keep other fields, replace qty/cost
        }

        return {
          object: {
            ...prevObj,
            components: updated,
            raw_materials: Array.from(merged.values()),
          },
        };
      });
    };
  }

  handleDeleteSelectedFor(type) {
    const selected = this.state.selectedIds[type] || [];
    const updated = (this.state.object[type] || []).filter(
      (item) => !selected.includes(item.id)
    );

    this.setState((prev) => ({
      object: {
        ...prev.object,
        [type]: updated,
      },
      selectedIds: {
        ...prev.selectedIds,
        [type]: [],
      },
    }));
  }

  renderBreakdownTable(title, type, onAdd, customChange) {
    const object = this.state.object;

    console.log("hey", object);
    return (
      <BreakdownTable
        title={title}
        data={object[type] || []}
        selectedIds={this.getSelectedIds(type)}
        onSelectAll={this.handleSelectAllFor(type)}
        onSelectOne={this.handleSelectOneFor(type)}
        onChange={
          type === "products"
            ? this.handleChangeQuantityForProducts()
            : this.handleChangeQuantityFor(type)
        }
        onAdd={onAdd}
        onDelete={() => this.handleDeleteSelectedFor(type)}
        disableAdd={!this.state.hasQuantity && !this.getObjectId()}
        hasQuantity={this.state.hasQuantity || !!this.getObjectId()}
        showUOM={true}
        disableQty={type === "components" ? false : true}
      />
    );
  }

  render() {
    const object = this.state.object;
    console.log("object", object);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h2
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => this.navigateBack()}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {label +
                  (schema.label || toDisplayCase(this.getCollectionName()))}
              </h2>
              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <FormFactory
                        schema={schema}
                        object={object}
                        onChange={this.onChange.bind(this)}
                        excludeFields={[
                          "raw_materials",
                          "others_raw_materials",
                          "additionalProduct",
                          "componentsBreakdown",
                          "rawMaterialsBreakdown",
                          "cost",
                          "products",
                          "components",
                        ]}
                      />
                    )}
                  </div>

                  {/* {this.renderBreakdownTable(
                    "Additional Products",
                    "products",
                    () => this.handleOpenAdditionalProduct()
                  )} */}

                  {/* {this.renderBreakdownTable(
                    "Additional Products",
                    "products",
                    () => this.handleOpenAdditionalProduct(),
                    this.handleChangeQuantityForProducts()
                  )} */}

                  {this.renderBreakdownTable(
                    "Components Breakdown",
                    "components",
                    () => this.handleOpenComponent()
                  )}

                  {this.renderBreakdownTable(
                    "Raw Materials Breakdown",
                    "raw_materials",
                    () => this.handleOpenRaw()
                  )}

                  {this.renderBreakdownTable(
                    "Other Raw Materials",
                    "others_raw_materials",
                    () => this.handleOpenRawOthers()
                  )}

                  <div className="mt-4 text-center">
                    <button
                      type="button"
                      className="btn fs-sm "
                      onClick={this.onClickBack.bind(this)}
                      style={{ backgroundColor: "#d1d1d1" }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn fs-sm text-white ms-3"
                      style={{ backgroundColor: "#82c14a" }}
                    >
                      <i className="bi text-white bi-file-earmark-check me-2"></i>
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ProductFormPage);
